import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Button = styled("a")`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 30px;
  border: none;
  color: #fff;
  border-radius: 50px;
  transition: ease-out 0.3s;
  font-size: 1rem;
  outline: none;

  position: relative;
  z-index: 1;
  background: rgb(178, 12, 78);
    
  &:hover {
    color: #000;
    cursor: pointer;
    box-shadow: 5px -5px 15px 0 rgba(178, 12, 78, 0.5),
      -5px 5px 15px 0 rgba(178, 12, 78, 0.5);
  }
  &:before {
    transition: 0.5s all ease;
    position: absolute;
    border-radius: 50px;
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    opacity: 0;
    content: '';
    background-color: #fff;
  }
  &:hover:before {
    transition: 0.5s all ease;
    left: 0;
    right: 0;
    opacity: 1;
    z-index: -1;
  }
`;
